import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { NEW_RELIC_SCRIPT } from './types';
export default _defineProperty({}, NEW_RELIC_SCRIPT, function (state) {
  return state.newRelicScript;
});